import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { Document, UserDocument, UserDocumentView } from '../../data/data.generated';
import { DocumentListResponse } from 'src/app/pages/document-library/document-library.component';

export class Documents {
  constructor(private _api: ApiService) {}

  public GetDocuments(listOptions: any): Observable<DocumentListResponse> {
    return this._api.Post('GetDocuments', listOptions);
  }

  public GetUserDocuments(): Observable<UserDocumentView[]> {
    return this._api.Get<UserDocumentView[]>('GetUserDocuments', {});
  }

  public CreateUserDocument(document: UserDocument): Observable<number> {
    return this._api.Get<number>('CreateUserDocument', {
      Object: JSON.stringify(document),
    });
  }

  public UpdateUserDocument(document: UserDocument): Observable<string> {
    return this._api.Get<string>('UpdateUserDocument', {
      Object: JSON.stringify(document),
    });
  }

  public GetDocumentDetails(documentId: number): Observable<Document> {
    return this._api.Get<Document>('GetDocumentDetails', { Id: documentId });
  }

  public DownloadDocument(document: Document, finished: (err: string) => void) {
    this._api.Download(
      'DownloadDocument',
      {
        Id: document.Id,
      },
      document.OriginalFileName,
      document.FileType.toLowerCase() == 'pdf'
        ? 'application/pdf'
        : 'application/octet-stream',
      finished,
    );
  }

  public DownloadUserDocument(document: UserDocument, finished: (err: string) => void) {
    const filename = document.Filename.toLowerCase();
    let mimeType = 'application/octet-stream';
    if (filename.endsWith('.pdf')) {
      mimeType = 'application/pdf';
    } else if (filename.endsWith('.png')) {
      mimeType = 'image/png';
    } else if (filename.endsWith('.jpeg')) {
      mimeType = 'image/jpeg';
    } else if (filename.endsWith('.jpg')) {
      mimeType = 'image/jpg';
    }

    this._api.Download(
      'DownloadUserDocument',
      {
        Id: document.Id,
      },
      document.Filename,
      mimeType,
      finished,
    );
  }

  public UploadUserDocument(id: number, files: File[]) {
    return this._api.Post(
      'UploadUserDocument',
      {
        Id: id,
      },
      files,
    );
  }
}
